import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(VBreadcrumbs, { staticClass: "pa-0 ml-3 text--black" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("customer_insights.bulk_upload.sub_title")) + " "
        ),
      ]),
      _c(
        VContainer,
        [
          _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { "no-gutters": "" } },
                [
                  _vm.isInlearning || _vm.isInretailpharma
                    ? _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              label: _vm.$t(
                                "customer_insights.label.organization"
                              ),
                              name: "id_organization",
                              placeholder: _vm.$t(
                                "customer_insights.label.organization"
                              ),
                              items: _vm.organizationsList,
                              rules: _vm.rules.organization,
                              "item-value": "id_organization",
                              "item-text": "name",
                              outlined: "",
                              dense: "",
                            },
                            on: { change: _vm.changeOrganization },
                            model: {
                              value: _vm.organization_id,
                              callback: function ($$v) {
                                _vm.organization_id = $$v
                              },
                              expression: "organization_id",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCol,
                    { attrs: { cols: "2" } },
                    [
                      _c(VSelect, {
                        staticClass: "m-0 mr-md-2",
                        attrs: {
                          label: _vm.label.year,
                          name: "year_id",
                          placeholder: _vm.label.year,
                          items: _vm.yearsList,
                          rules: _vm.rules.year,
                          "item-value": "id",
                          "item-text": "name",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.year_id,
                          callback: function ($$v) {
                            _vm.year_id = $$v
                          },
                          expression: "year_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          label: _vm.label.forecast,
                          name: "forecast",
                          placeholder: _vm.label.forecast,
                          items: _vm.ForecastList,
                          rules: _vm.rules.forecast,
                          "item-value": "id",
                          "item-text": "name",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.forecast_id,
                          callback: function ($$v) {
                            _vm.forecast_id = $$v
                          },
                          expression: "forecast_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCard,
                    { staticClass: "min-w-0 w-full card-bulk pt-2 pb-0 mb-0" },
                    [
                      _c(
                        VCol,
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                dragover: function ($event) {
                                  $event.preventDefault()
                                },
                                drop: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "drag-file text-center pt-1 mt-1 ",
                                  on: { drop: _vm.dropFile },
                                },
                                [
                                  !_vm.hasFile
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column justify-space-between align-center",
                                        },
                                        [
                                          _c(VImg, {
                                            attrs: {
                                              width: "64px",
                                              src: require("@/assets/upload.png"),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.hasFile
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customer_insights.bulk_upload.drag_here"
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(VFileInput, {
                                    staticClass: "upload-input-file",
                                    attrs: {
                                      rules: _vm.rules.file,
                                      accept:
                                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                      chips: "",
                                      placeholder: _vm.$t(
                                        "customer_insights.bulk_upload.search_computer"
                                      ),
                                      "prepend-icon": "",
                                      "show-size": "",
                                      "truncate-length": "35",
                                      solo: "",
                                      flat: "",
                                    },
                                    on: { change: _vm.importXlsx },
                                    model: {
                                      value: _vm.xlsxFile,
                                      callback: function ($$v) {
                                        _vm.xlsxFile = $$v
                                      },
                                      expression: "xlsxFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                      !_vm.hasFile ? _c(VDivider) : _vm._e(),
                      !_vm.hasFile
                        ? _c(
                            VCol,
                            {
                              staticClass: "text-center download",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "customer_insights.bulk_upload.download_it_now"
                                    )
                                  ) + ". "
                                ),
                                _vm.forecast_id != 0
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "customer_insights.bulk_upload.template"
                                          )
                                        ) +
                                          " " +
                                          _vm._s(_vm.selectedItemName)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-md-1 mb-2 btn-block-xs-only",
                                  attrs: {
                                    type: "button",
                                    color: "primary",
                                    dense: "",
                                    outlined: "",
                                    disabled:
                                      _vm.forecast_id == 0 ||
                                      _vm.loading_download,
                                    loading: _vm.loading_download,
                                  },
                                  on: { click: _vm.downloadXlsx },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-download"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "customer_insights.button.download"
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("dialog-confirmation-component", {
            ref: _vm.DIALOG_REWRITE_SUBMIT,
            attrs: {
              title: "Confirmación",
              text: "Ya existen datos registrados para el año seleccionado ¿Está seguro de sobreescribir la carga anterior?",
            },
            on: { onConfirm: _vm.onSubmitRewrite },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }